import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';
import {
  closeInAppOAuthBrowser,
  parseTokenFromOAuthDeepLink,
} from '../utils/oauthNativeHandoff';

/**
 * dekosta://auth/callback#token=... ile açıldığında token’ı işler ve dashboard’a yönlendirir.
 */
export default function CapacitorOAuthBridge() {
  const navigate = useNavigate();
  const { finalizeOAuthToken } = useAuth();
  const lastHandledUrlRef = useRef('');
  const processingRef = useRef(false);

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return undefined;

    const handleUrl = async (url) => {
      if (!url) return;
      const token = parseTokenFromOAuthDeepLink(url);
      if (!token) return;
      if (lastHandledUrlRef.current === url) return;
      if (processingRef.current) return;
      processingRef.current = true;
      lastHandledUrlRef.current = url;
      try {
        let ok = false;
        try {
          ok = await finalizeOAuthToken(token);
          if (!ok) lastHandledUrlRef.current = '';
        } catch (e) {
          console.warn('[oauth] finalizeOAuthToken failed', e);
          lastHandledUrlRef.current = '';
        }
        await closeInAppOAuthBrowser();
        if (ok) {
          toast.success('Giriş başarılı');
          navigate('/dashboard', { replace: true });
        } else {
          toast.error('Oturum doğrulanamadı');
          navigate('/login', { replace: true });
        }
      } finally {
        processingRef.current = false;
      }
    };

    let listenerPromise = App.addListener('appUrlOpen', ({ url }) => {
      handleUrl(url);
    });

    App.getLaunchUrl()
      .then((r) => {
        if (r?.url) handleUrl(r.url);
      })
      .catch(() => {});

    return () => {
      listenerPromise.then((h) => h.remove()).catch(() => {});
    };
  }, [finalizeOAuthToken, navigate]);

  return null;
}
